import type { FC, ReactNode } from 'react'
import type { FeatureKey } from '@/constants/features'

import { ReportingPreview } from '@/components/features/reporting-preview'
import { ExpensePreview } from '@/components/features/expense-preview'
import { InsightsPreview } from '@/components/features/insights-preview'
import { ForecastPreview } from '@/components/features/forecast-preview'
import { RevenuePreview } from '@/components/features/revenue-preview'
import { BudgetPreview } from '@/components/features/budget-preview'

const PREVIEWS: Record<FeatureKey, FC> = {
    'automated-reporting': ReportingPreview,
    'expense-tracking': ExpensePreview,
    'ai-insights': InsightsPreview,
    'cash-flow-forecasting': ForecastPreview,
    'revenue-analytics': RevenuePreview,
    'budget-management': BudgetPreview
}

interface FeaturePreviewProps {
    feature: FeatureKey
}

export const FeaturePreview: FC<FeaturePreviewProps> = ({ feature }): ReactNode => {
    const Preview = PREVIEWS[feature]

    return <Preview />
}
